import React from "react";
import { gql, useQuery } from "@apollo/client";
import { Navigate, useParams } from "react-router-dom";
import { getClosedSubjectIdBySlug } from "./closedSubjects";

const SUBJECT_ROUTE_GUARD_QUERY = gql`
  query SubjectRouteGuard {
    subjects {
      id
      slug
    }
  }
`;

function SubjectRouteGuard({ children }) {
  const { subjectSlug } = useParams();
  const { data, loading, error } = useQuery(SUBJECT_ROUTE_GUARD_QUERY, {
    fetchPolicy: "cache-first",
  });

  const closedSubjectId = getClosedSubjectIdBySlug(
    subjectSlug,
    data?.subjects
  );

  if (closedSubjectId) {
    return <Navigate to={`/subject-closed/${closedSubjectId}`} replace />;
  }

  // Do not mount a subject page before its slug has been checked.
  if (loading) {
    return <div aria-live="polite">Lade Fach…</div>;
  }

  // If the slug cannot be verified, keep subject content closed instead of
  // briefly mounting a page that may belong to a closed subject.
  if (error) {
    return <div role="alert">Das Fach konnte nicht geladen werden.</div>;
  }

  return children;
}

export default SubjectRouteGuard;
